import { render, staticRenderFns } from "./Finalize.vue?vue&type=template&id=cb546ea6&scoped=true&lang=pug&"
import script from "./Finalize.vue?vue&type=script&lang=js&"
export * from "./Finalize.vue?vue&type=script&lang=js&"
import style0 from "./Finalize.vue?vue&type=style&index=0&id=cb546ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb546ea6",
  null
  
)

export default component.exports